import { render, staticRenderFns } from "./TaskNavigationListItem.vue?vue&type=template&id=3887a3ad&scoped=true&"
import script from "./TaskNavigationListItem.vue?vue&type=script&lang=js&"
export * from "./TaskNavigationListItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskNavigationListItem.vue?vue&type=style&index=0&id=3887a3ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887a3ad",
  null
  
)

export default component.exports